import { useEffect, useState, useMemo } from "react";
import { Form } from "reactstrap";
import { APIUS } from "../../../../../../../../config/apius";
import Modal from "react-bootstrap/Modal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "bulma/css/bulma.css";
import "../../../../../../../../index.css";
import ToastError from "../../../../../../../NotificationToast/ToastError";
import ToastSuccess from "../../../../../../../NotificationToast/ToastSuccess";
import { faXmark, faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

const isActiveStatus = (value) => {
  return (
    value === true ||
    Number(value) === 1
  );
};

export default function ModalStatus(props) {
  
  const token = localStorage.getItem("token");

  const idUser = localStorage.getItem("id_admin")?.replace(/[|&;$%@"<>()+,]/g,"");

  const [isSubmitting,setIsSubmitting] = useState(false);


  const [form, setForm] = useState({
    state_form: "",
    tanggal_nonaktif: "",
    keterangan_nonaktif: "",
  });


  const fetchParams = useMemo(
    () => ({
      headers: {
        Authorization: `${token}`,
        "Content-Type":
          "application/json",
      },
    }),
    [token]
  );

  // =========================
  // ISI DATA UPDATE
  // =========================
  useEffect(() => {
    setForm({
      state_form: (props.isActive ?? (props?.dataUpdate?.state_form != null
        ? isActiveStatus(props.dataUpdate.state_form)
        : String(props?.dataUpdate?.keterangan_status || "Aktif").trim().toLowerCase() === "aktif")) ? 1 : 0,
      
      tanggal_nonaktif:
        props?.dataUpdate
          ?.tanggal_nonaktif
          ? String(
              props.dataUpdate
                .tanggal_nonaktif
            ).slice(0, 10)
          : "",

        keterangan_nonaktif:props?.dataUpdate?.keterangan_nonaktif ?? "",
    });
  }, [props?.dataUpdate, props.show, props.isActive]);

  const handleChange = (event) => {
    const { name, value } =
      event.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleStatusToggle = (
    event
  ) => {
    setForm((prev) => ({
      ...prev,
      state_form:
        event.target.checked
          ? 1
          : 0,
    }));
  };

  // =========================================
  // SUBMIT UPDATE
  // =========================================
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    if (!form.state_form && (!form.tanggal_nonaktif || !form.keterangan_nonaktif.trim())) {
      ToastError.fire({
        icon: "error",
        title: "Tanggal dan keterangan wajib diisi untuk status nonaktif",
      });

      return;
    }

    const studentId = props.dataUpdate?.ysb_student_id ?? props.id;
    if (studentId == null || studentId === "") {
      ToastError.fire({ icon: "error", title: "ID siswa tidak ditemukan" });
      return;
    }

    setIsSubmitting(true);

    try {
      const response = await APIUS.put(
        `/api/student-admitted/activate/${encodeURIComponent(studentId)}`,
        {
         
          state_form: Number(
              form?.state_form
            ),

          tanggal_nonaktif:
            form.state_form ? null : form.tanggal_nonaktif,

          keterangan_nonaktif:
            form.state_form ? null : form.keterangan_nonaktif.trim(),

          user_id: idUser,
        },
        fetchParams
      );

      if (response?.data?.error || response?.data?.success === false ||
          response?.status < 200 || response?.status >= 300) {
        throw new Error(response?.data?.message || "Gagal memperbarui status siswa");
      }

      if (response?.status === 200 ) {
        ToastSuccess.fire({
          icon: "success",
          title:
            response?.data?.message ||
            "Status siswa berhasil diperbarui",
        });

        props.onStatusSaved?.({
          state_form: Number(form.state_form),
          tanggal_nonaktif: form.state_form ? null : form.tanggal_nonaktif,
          keterangan_nonaktif: form.state_form ? null : form.keterangan_nonaktif.trim(),
        });
        props.GetResponseData?.();
        props.onHide();
      }
    } catch (error) {
      ToastError.fire({
        icon: "error",
        title:
          error?.response?.data?.message || error?.message ||
          "Gagal memperbarui status siswa",
      });
    } finally {
      setIsSubmitting(false);
    }
  };


  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      centered
      backdrop="static"
      keyboard={false}
      dialogClassName="sims-modal-dialog"
      contentClassName="sims-modal-content"
      aria-labelledby="modal-status-siswa"
    >
      <div className="sims-modal-header">
        <div><h5 id="modal-status-siswa" className="sims-modal-title">Status Siswa</h5></div>
        <button
          type="button"
          className="sims-modal-close"
          onClick={props.onHide}
          disabled={isSubmitting}
           aria-label="Tutup modal"
        >
          <FontAwesomeIcon
            icon={faXmark}
          />
        </button>
      </div>

      <Form onSubmit={handleSubmit}>
      <Modal.Body className="sims-modal-body mt-1 mx-2">
          <fieldset disabled={isSubmitting} style={{ border: 0, padding: 0, margin: 0 }}>
          <div className="sims-form-grid">
            <div className="sims-form-group">
              <label
                className="sims-form-label"
                
              >
                Nama Siswa
              </label>
              <div className="sims-text-bold">{props.dataUpdate?.nama_siswa || props.dataUpdate?.name_student || "-"}</div>
            </div>

            <div className="sims-form-group">
              <label
                className="sims-form-label"
                
              >
                NISN
              </label>
              <div className="sims-text-bold">{props.dataUpdate?.nisn || "-"}</div>

            </div>

            <div className="sims-form-group sims-form-span-2">
              <div className="sims-status-form-card">
                <div className="sims-status-form-info">
                  <span style={{fontSize: "14px"}} className="sims-status-form-title">Status Siswa</span>
                  {/* <span className="sims-status-form-description">Atur apakah siswa aktif di kelas ini.</span> */}
                </div>
                <div className="sims-status-form-action">
                  <label className="sims-toggle">
                    <input type="checkbox" checked={Boolean(form.state_form)} onChange={handleStatusToggle} aria-label="Status siswa aktif" />
                    <span className="sims-toggle-slider" />
                  </label>
                  <span className={`sims-status-label ${form.state_form ? "is-active" : "is-inactive"}`}>
                    {form.state_form ? "Aktif" : "Tidak Aktif"}
                  </span>
                </div>
              </div>
            </div>
            {!form.state_form && (
              <>
              <div className="sims-form-group sims-form-span-2">
                <label className="sims-form-label" htmlFor="tanggal-status-siswa">Tanggal Nonaktif <span>*</span></label>
                <input
                  id="tanggal-status-siswa"
                  type="date"
                  className="sims-form-input"
                  name="tanggal_nonaktif"
                  value={form.tanggal_nonaktif}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="sims-form-group sims-form-span-2">
                <label className="sims-form-label" htmlFor="keterangan-status-siswa">Keterangan <span>*</span></label>
                <textarea
                  id="keterangan-status-siswa"
                  className="sims-form-input pt-2"
                  rows={6}
                  style={{ minHeight: 140, resize: "vertical" }}
                  name="keterangan_nonaktif"
                  value={form.keterangan_nonaktif}
                  onChange={handleChange}
                  placeholder="Masukkan alasan siswa dinonaktifkan"
                  required
                />
              </div>
              </>
            )}
          </div>
          </fieldset>
        </Modal.Body>

        <div className="sims-modal-footer">
          <button
            type="button"
            className="sims-modal-cancel"
            onClick={props.onHide}
            disabled={isSubmitting}
          >
            Batal
          </button>

          <button
            type="submit"
            className="sims-modal-submit"
            disabled={isSubmitting}
          >

            {isSubmitting ? (
              <>
                <span className="sims-button-spinner" />
                <span>Memperbarui...</span>
              </>
            ) : (
              <>
                <FontAwesomeIcon
                  icon={faFloppyDisk}
                />

                <span>Perbarui</span>
              </>
            )}
          </button>
        </div>
      </Form>
    </Modal>
  );
}
